<template>
  <div class="payment">

    <div v-if="!failedPayment">

      <!-- Account Holder Name -->
      <div class="wwf-field" >
        <input
          id="acount-holder-name"
          name="acount-holder-name"
          title="Required"
          type="text"
          v-model="accountTitle"
          v-validate="{ required: true, regex: /^[a-zA-Z ]+$/ }"
          data-vv-validate-on="change"
          :class="{ 'error': errors.has('acount-holder-name'), 'empty': !accountTitle }"
          autocomplete="off"
        />
        <label for="title">Bank account holder name</label>
      </div>

      <!-- BSB -->
      <div class="wwf-field">
        <input
          id="acount-bsb"
          name="acount-bsb"
          title="Required"
          type="text"
          v-model="accountRouting"
          v-validate="{ required: true, regex: /^[0-9]{3}(-?)[0-9]{3}\b$/ }"
          data-vv-validate-on="change"
          :class="{ 'error': errors.has('acount-bsb'), 'empty': !accountRouting }"
          autocomplete="off"
        />
        <label for="title">Bank account BSB</label>
      </div>

      <!-- Account Number -->
      <div class="wwf-field">
        <input
          id="acount-number"
          name="acount-number"
          title="Required"
          type="text"
          v-model="accountNumber"
          v-validate="{ required: true, regex: /^[0-9]{6,10}$/ }"
          data-vv-validate-on="change"
          :class="{ 'error': errors.has('acount-number'), 'empty': !accountNumber }"
          autocomplete="off"
        />
        <label for="title">Bank account number</label>
      </div>
    </div>

    <!-- ERRORS -->
    <div class="errors" v-if="serverError">
      <label>{{ serverError }}</label>
    </div>

    <div class="form-buttons" v-if="!failedPayment">
      <button
        type="button"
        :class="{ disabled: !enablePayButton() }"
        :disabled="!enablePayButton()"
        class="pay-now"
        href="#form-top"
        data-animation-duration="300"
        data-animation-easing="swing"
        id="pay-button"
        @click="pay"
        data-smooth-scroll
        data-threshold="75"
      >
        Pay Now
      </button>
    </div>

    <div class="form-buttons" v-if="failedPayment">
      <button
        type="button"
        class="pay-now"
        href="#form-top"
        data-animation-duration="300"
        data-animation-easing="swing"
        id="retry-button"
        @click="retry"
        data-smooth-scroll
        data-threshold="75"
      >
        Retry
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "DirectDebit",
  data() {
    return {
      accountNumber: "",
      accountRouting: "",
      accountTitle: "",
      serverError: "",
      failedPayment: false,
      isPayButtonDisabled: false,
    };
  },
  mounted() {},
  computed: mapState({
    donation: (state) => state.donation.donation,
  }),
  methods: {
    togglePayButtonDisabled(value) {
      //disable pay-button
      this.isPayButtonDisabled = value;
    },
    enablePayButton() {
      return this.accountTitle &&
        this.accountNumber &&
        this.accountRouting &&
        (!this.errors || !this.errors.items || this.errors.items.length === 0)
        ? true
        : false &&
        !this.togglePayButtonDisabled;
    },
    pay() {
      if (this.isPayButtonDisabled) {
        return;
      }

      this.togglePayButtonDisabled(true);

      this.$store.dispatch('logFormPayAttempt');

      return new Promise((resolve, reject) => {
        this.serverError = "";
        this.$validator.validateAll().then((result) => {
          if (!result) {
            const errMessage = "Direct Debit checkout is invalid.";
            this.$store.dispatch('logFormPayFail', errMessage);
            reject(errMessage);
          } else {
            this.$emit("success", {
              accno: this.accountNumber,
              accrouting: this.accountRouting,
              acctitle: this.accountTitle,
            });
          }
        });
      });
    },
    retry() {
      this.$emit("retry");
      this.resetForm();
    },
    resetForm() {
      this.accountNumber = "";
      this.accountRouting = "";
      this.accountTitle = "";
      this.serverError = undefined;
    },
    reset(error) {
      this.resetForm();
      if (error) {
        this.serverError = error;
        this.failedPayment = true;
      } else {
        this.failedPayment = false;
      }
    },
  },
};
</script>

<style scoped>
#acount-number {
  margin-bottom: 2rem;
}

.errors label {
  font-size: 15px;
  color: var(--errorColor);
  display: block;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// DirectDebit.vue?787e2bbf